import { z } from 'zod';
import { ArrowDirection } from '@/api/entities/vehicule-check-type-check-point';
import { CheckPointType } from '@/api/entities/check-point';

export const vehiculeCheckTypeCheckPointSchema = z.object({
  id: z.string().optional(),
  vehiculeCheckTypeId: z.string().nullish(),
  checkPointId: z.string().nullish(),
  useArrow: z.boolean().default(false),
  arrowDirection: z.nativeEnum(ArrowDirection).nullish(),
  useInformation: z.boolean().default(false),
  information: z.string().nullish(),
  type: z.nativeEnum(CheckPointType).nullish(),
  index: z.number().nullish(),
});

export type TVehiculeCheckTypeCheckPointSchema = z.infer<
  typeof vehiculeCheckTypeCheckPointSchema
>;
